export default {
  id: null,
  createdAt: null,
  hsmId: null,
  hsmName: null,
  hsmText: null,
  variaveisHsmList: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/hsmmodel.js